export enum UserLocalization {
  en_US = 'en_US',
  ru_UA = 'ru_UA',
  uk_UA = 'uk_UA',
  hr_HR = 'hr_HR',
  el_GR = 'el_GR',
}

export interface Locale {
  [UserLocalization.en_US]?: string;
  [UserLocalization.ru_UA]?: string;
  [UserLocalization.uk_UA]?: string;
  [UserLocalization.hr_HR]?: string;
  [UserLocalization.el_GR]?: string;
  [key: string]: string | undefined;
}

export interface EnumLocalizationFields {
  field: string;
  locale: Locale;
  color: string;
}

export interface EnumLocalization {
  enumName: string;
  businessObject: string; // EntityTypeName
  enumFields: EnumLocalizationFields[];
}
